import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { StaticImage } from "gatsby-plugin-image";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 8000, min: 1601 },
    items: 6,
  },
  desktop: {
    breakpoint: { max: 1600, min: 1400 },
    items: 5,
  },
  landscape: {
    breakpoint: { max: 1399, min: 1200 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1199, min: 900 },
    items: 3.5,
  },
  mobilelg: {
    breakpoint: { max: 899, min: 667 },
    items: 2.5,
  },
  mobile: {
    breakpoint: { max: 666, min: 0 },
    items: 1,
  },
};

function Awads(props) {
  return (
    <>
      <Carousel
        responsive={responsive}
        arrows={false}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={3000}
      >
        <div className={props.content ? "awards_item " : "awards_item small"}>
          <div className="awards_img">
            <StaticImage
              src="../../images/awards/inc-5000.webp"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["auto"]}
              width={180}
              height={130}
            />
            <h5>INC. 5000</h5>
            <p>America's Fastest Growing Companies</p>
          </div>
        </div>

        <div className={props.content ? "awards_item " : "awards_item small"}>
          <div className="awards_img">
            <StaticImage
              src="../../images/awards/rank-watch.webp"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["auto"]}
              width={180}
              height={130}
            />
            <h5>Rank Watch</h5>
            <p>Top Web Development Agencies 2023</p>
          </div>
        </div>

        <div className={props.content ? "awards_item " : "awards_item small"}>
          <div className="awards_img">
            <StaticImage
              src="../../images/awards/Horizon_Sliver.webp"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["auto"]}
              width={180}
              height={130}
            />
            <h5>Horizon Award</h5>
            <p>Silver Awards Winner 2020</p>
          </div>
        </div>

        <div className={props.content ? "awards_item " : "awards_item small"}>
          <div className="awards_img">
            <StaticImage
              src="../../images/awards/Clutch.webp"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["auto"]}
              width={180}
              height={130}
            />
            <h5>Clutch</h5>
            <p>Top 1000 Companies</p>
          </div>
        </div>

        <div className={props.content ? "awards_item " : "awards_item small"}>
          <div className="awards_img">
            <StaticImage
              src="../../images/awards/right-firms.webp"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["auto"]}
              width={180}
              height={130}
            />
            <h5>Right firms</h5>
            <p>Top Mobile App Development Company 2023</p>
          </div>
        </div>

        <div className={props.content ? "awards_item " : "awards_item small"}>
          <div className="awards_img">
            <StaticImage
              src="../../images/awards/top_developer.webp"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["auto"]}
              width={180}
              height={130}
            />
            <h5>Top Developers</h5>
            <p>Top Entertainment App Developers</p>
          </div>
        </div>
        <div className={props.content ? "awards_item " : "awards_item small"}>
          <div className="awards_img">
            <StaticImage
              src="../../images/awards/expertise-logo.webp"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["auto"]}
              width={180}
              height={130}
            />
            <h5>Expertise</h5>
            <p>Best Mobile App Developer</p>
          </div>
        </div>
        <div className={props.content ? "awards_item " : "awards_item small"}>
          <div className="awards_img">
            <StaticImage
              src="../../images/awards/top_Reated.webp"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["auto"]}
              width={180}
              height={130}
            />
            <h5>Software World</h5>
            <p>Top App Development Companies</p>
          </div>
        </div>
        <div className={props.content ? "awards_item " : "awards_item small"}>
          <div className="awards_img">
            <StaticImage
              src="../../images/awards/web-excellence-award.webp"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["auto"]}
              width={180}
              height={130}
            />
            <h5>Web Excelllence</h5>
            <p>Web Excellence Awards</p>
          </div>
        </div>
        <div className={props.content ? "awards_item " : "awards_item small"}>
          <div className="awards_img">
            <StaticImage
              src="../../images/awards/Horizon.webp"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["auto"]}
              width={180}
              height={130}
            />
            <h5>Horizon Award</h5>
            <p>Gold Awards Winner 2020</p>
          </div>
        </div>
        <div className={props.content ? "awards_item " : "awards_item small"}>
          <div className="awards_img">
            <StaticImage
              src="../../images/awards/dot-com.webp"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["auto"]}
              width={180}
              height={130}
            />
            <h5>Dot Comm</h5>
            <p>Excellence in Web Creativity & Digital Communication</p>
          </div>
        </div>
      </Carousel>
    </>
  );
}

export default Awads;
